module.exports = {
	"root": "findify-components--cards--content",
	"linkIcon": "findify-components--cards--content__linkIcon",
	"image-wrap": "findify-components--cards--content__image-wrap",
	"imageWrap": "findify-components--cards--content__image-wrap",
	"image": "findify-components--cards--content__image",
	"title": "findify-components--cards--content__title",
	"description": "findify-components--cards--content__description"
};